import {
  useEntityNotesSuspense,
  type EntityNotesProps
} from "@swivu/client-api";
import { NotesList } from "./NotesList.js";

type Props = EntityNotesProps & { title: string; slug?: string };
const EntityNotes = (variables: Props) => {
  const { data } = useEntityNotesSuspense(variables.entity_type)({
    variables
  });
  return <NotesList notes={data} title={variables.title} />;
};

export { EntityNotes };
